import logoVariants from '@/assets/img/logo';
import { HStack, Image } from '@chakra-ui/react';
import React from 'react';
import LogoSpinner from '../LogoSpinner';

interface Props {
  isLoading?: boolean;
  spinnerWidth?: string;
}

const LoadingLogo = ({ isLoading = true, spinnerWidth }: Props) => {
  return (
    <HStack spacing={'24px'} alignItems={'center'}>
      <LogoSpinner isLoading={isLoading} width={spinnerWidth} />
      <Image src={logoVariants.mediumBlueText145x31} width={'148px'} objectFit={'cover'} />
    </HStack>
  );
};

export default LoadingLogo;
